// actions/searchForm.js
import { SET_SEARCH_FORM } from "../constants/searchForm";

export const setSearchForm = (formData) => ({
	type: SET_SEARCH_FORM,
	payload: formData,
});
